/** 设置显示模式 */
export function setMode(mode) {
  if (mode) {
    document.documentElement.setAttribute('theme', 'dark');
  } else {
    document.documentElement.removeAttribute('theme');
  }
}
// 获取当前模式
// export function getMode() {
//   if (document.documentElement.hasAttribute('theme')) {
//     return false
//   } else {
//     return true
//   }
// }

/**
 * 数字运算（主要用于小数点精度问题）
 * [see](https://juejin.im/post/6844904066418491406#heading-12)
 * @param {number} a 前面的值
 * @param {"+"|"-"|"*"|"/"} type 计算方式
 * @param {number} b 后面的值
 * @example
 * ```js
 * // 可链式调用
 * const res = computeNumber(1.3, "-", 1.2).next("+", 1.5).next("*", 2.3).next("/", 0.2).result;
 * console.log(res);
 * ```
 */
export function computeNumber(a, type, b) {
  /**
   * 获取数字小数点的长度
   * @param {number} n 数字
   */
  function getDecimalLength(n) {
    const decimal = n.toString().split('.')[1];
    return decimal ? decimal.length : 0;
  }
  /**
   * 修正小数点
   * @description 防止出现 `33.33333*100000 = 3333332.9999999995` && `33.33*10 = 333.29999999999995` 这类情况做的处理
   * @param {number} n
   */
  const amend = (n, precision = 15) =>
    parseFloat(Number(n).toPrecision(precision));
  const power = Math.pow(
    10,
    Math.max(getDecimalLength(a), getDecimalLength(b))
  );
  let result = 0;

  a = amend(a * power);
  b = amend(b * power);

  switch (type) {
    case '+':
      result = (a + b) / power;
      break;
    case '-':
      result = (a - b) / power;
      break;
    case '*':
      result = (a * b) / (power * power);
      break;
    case '/':
      result = a / b;
      break;
  }

  result = amend(result);

  return {
    /** 计算结果 */
    result,
    /**
     * 继续计算
     * @param {"+"|"-"|"*"|"/"} nextType 继续计算方式
     * @param {number} nextValue 继续计算的值
     */
    next(nextType, nextValue) {
      return computeNumber(result, nextType, nextValue);
    },
  };
}

/** 将秒转为天数,向上取整 */
export function secondsToDays(seconds) {
  if (seconds >= 1 && seconds <= (24 * 60 * 60)) {
    return 1
  } else {
    // console.log('seconds', seconds);
    // console.log('ceil', Math.ceil(seconds / (24 * 60 * 60)));
    return Math.ceil(seconds / (24 * 60 * 60))
  }
}

export function convertToDecimal(value) {
  console.log('value', value);
  if (typeof value === "number") {
    return value; // 如果输入已经是普通数值，直接返回
  } else if (typeof value === "string") {
    const match = /^([-+]?[\d.]+)e([-+]?\d+)$/.exec(value);
    if (match) {
      const coefficient = parseFloat(match[1]);
      const exponent = parseInt(match[2]);
      console.log('exponent', exponent);
      return coefficient * Math.pow(10, exponent);
    } else {
      return parseFloat(value); // 如果不是科学计数法，尝试将字符串转换为数值
    }
  } else {
    throw new Error("Invalid input type");
  }
}
